module.exports = __webpack_public_path__ + "assets/img/btn-complete-green.1cc4e87f.svg";